module.exports = __webpack_public_path__ + "img/Sainaplay.8a20d398.svg";